import React from 'react'
import { withRouter } from 'react-router-dom';

import { Section, Table, InfosBar, Text, Empty, ExternalLink } from 'components';
import { Button, Container, Dimmer, Loader, Icon } from 'semantic-ui-react'

import { ModalInviteUser } from 'modals';

import { Typeof, Functions } from 'utils';

import { API } from 'services';

const USERS_PER_PAGE = 10;

class PaneUsers extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      users: [],
      userCriteria: '',
      showUserInvitationModal: false
    };

    this.handleUserReload = this.handleUserReload.bind(this);
    this.handleUserSearch = this.handleUserSearch.bind(this);

    this.toggleUserInvitationModal = this.toggleUserInvitationModal.bind(this);
    this.handleUserInvitationModal = this.handleUserInvitationModal.bind(this);
  }

  componentDidMount() {
    this.handleUserReload();
  }

  handleUserSearch(criteria) {

    this.setState({
      userCriteria: criteria
    });
  }

  handleUserInvitationModal(user) {

    if (Typeof.object(user)) {

      let users = [...this.state.users];
      users.push(user);

      this.setState({
        users: users
      });
    }

    this.toggleUserInvitationModal();
  }

  toggleUserInvitationModal() {

    this.setState({
      showUserInvitationModal: !this.state.showUserInvitationModal
    });

  }

  handleUserReload() {
    this.setState({
      loading: true
    }, () => {

      API.get(`clinics/${this.props.clinic.id}/veterinarians`)
        .then((response) => {

          this.setState({
            users: response.data,
            loading: false
          });

        })
        .catch(() => {

          this.setState({
            loading: false
          });

        })
    });
  }

  render() {

    const { users } = this.state;

    let columns = [
      {
        id: 'email',
        header: 'Adresse e-mail',
        value: (user) => user.email,
        render: (user, email) => {
          return (
            <ExternalLink target={`mailto:${email}`}>
              <Icon name="mail" />
              <Text>{email}</Text>
            </ExternalLink>
          )
        },
        fit: true
      },
      {
        id: 'lastname',
        header: 'Nom',
        value: (user) => user.lastname,
        render: (user, lastname) => {
          if (!Typeof.string(lastname)) {
            return <Empty />;
          }

          return (
            <Text style={{ "uppercase": true }}>{lastname}</Text>
          )
        },
        fit: true
      },
      {
        id: 'firstname',
        header: 'Prénom',
        value: (user) => user.firstname,
        render: (user, firstname) => {
          if (!Typeof.string(firstname)) {
            return <Empty />;
          }

          return (
            <Text style={{ "capitalize": true }}>{firstname}</Text>
          )
        }
      },
      {
        id: 'phone',
        header: 'Numéro de téléphone',
        value: (user) => user.phone?.trim(),
        render: (user, phone) => {

          if (!phone) {
            return <Empty />;
          }

          return (
            <ExternalLink target={`tel:${phone}`}>
              <Icon name="phone" />
              <Text>{Functions.formatPhone(phone)}</Text>
            </ExternalLink>
          )
        },
        fit: true
      },
      {
        id: 'activated',
        header: 'Actif',
        value: (user) => user.activated,
        render: (user, activated) => {

          return (
            <Icon name={activated ? 'checkmark' : 'times'} color={activated ? 'green' : 'red'} />
          )
        },
        fit: true
      }
    ];

    return (
      <React.Fragment>
        <Container>

          {/* Users */}
          <Section title="Vétérinaires" onSearch={this.handleUserSearch} actions={[
            <Button circular icon="sync" onClick={this.handleUserReload} key={0} />
          ]}>

            {users.length > 0 ? (

              <React.Fragment>

                {/* Number of available users */}
                <InfosBar mode="column">
                  <span>{users.length > 1 ? `${users.length} vétérinaire disponibles` : '1 vétérinaire disponible'}</span>
                  <Button icon="add" content="Inviter un utilisateur" onClick={this.toggleUserInvitationModal} key={0} />
                </InfosBar>

                {/* users list */}
                <Table columns={columns}
                  criteria={this.state.userCriteria}
                  items={users}
                  itemsPerPage={USERS_PER_PAGE}
                  messageEmpty="Aucun vétérinaire ne correspond à votre recherche"
                />

              </React.Fragment>

            ) : (

              // No user available
              <InfosBar mode="row">
                <span>Aucun vétérinaire disponible</span>
              </InfosBar>

            )}

            <Dimmer active={this.state.loading} inverted>
              <Loader inverted>Chargement...</Loader>
            </Dimmer>

          </Section>

        </Container>

        {/* Modal invite user */}
        {this.state.showUserInvitationModal &&
          <ModalInviteUser clinic={this.props.clinic} onClose={this.handleUserInvitationModal} />
        }

      </React.Fragment>
    );
  }
}

export default withRouter(PaneUsers);
